export enum DeliveryRates {
  DAILY = 'Daily',
  WEEKLY = 'Weekly',
}
